import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import './CommentSection.scss'
import { formatTime } from '../../../helpers/utilities';
import ProfilePicture from '../ProfilePicture/ProfilePicture';
import { getProfilePublicPath } from '../../../helpers/profilePaths';

const Comment = ({comment}) => {
    const navigate = useNavigate();
    const [expanded, setExpanded] = useState(false);
    const isLong = comment.content.length > 30; // adjust threshold as needed

    const profilePath = getProfilePublicPath(comment.user);
    const handleProfileClick = () => {
        if (profilePath) navigate(profilePath);
    };

    const rawUsername = comment.user?.userName || comment.user?.username || '';
    const displayName = rawUsername
        ? (rawUsername.startsWith('@') ? rawUsername.toUpperCase() : `@${rawUsername.toUpperCase()}`)
        : 'USER';

    return (
        <div className="comment">
            <ProfilePicture classNames={'avatar'} imgUrl={comment.user?.profilePicture} no_edit={true} showIcon={false} width={32} height={32} handleClick={handleProfileClick} />
            <div className="content">
                <span className="fs-xxs fg-crea fw-medium-bold pt-4">
                    <span className="commenter-name" onClick={handleProfileClick}>{displayName}</span> <span className="timestamp">
                        {formatTime(comment.created_at)}
                    </span>
                </span>
                <span className={`text ${expanded ? "expanded" : ""}`}>
                    {comment.content.split('\n').map((line, index) => (
                        <React.Fragment key={index}>
                            {line}
                            {index < comment.content.split('\n').length - 1 && <br />}
                        </React.Fragment>
                    ))}
                </span>
                {isLong && (
                    <button
                        className="btn-link btn-more"
                        onClick={() => setExpanded(!expanded)}
                    >
                        {expanded ? "Show Less" : "More"}
                    </button>
                )}
            </div>
        </div>
    )
}

export default Comment